export default __webpack_public_path__ + "static/media/esb-logo-gray-400.b4e07929.svg";